export default __webpack_public_path__ + "static/media/PILLS.508a064c.png";